import "./style.scss";
import { FC } from "react";
import { AOPMaltaInvoiceDEData } from "@/src/types/admissionOffice";
import { getInvoiceDoubleLangRegistry, type InvoiceDoubleLangCountry, type InvoiceSecondLangCode } from "../invoiceLetterDoubleLangRegistry";
import { getAdmissionOfficePreviewBackground } from "@/src/utils/admissionOffice/getAdmissionOfficePreviewBackground";

interface AOPPrevProps {
  country: InvoiceDoubleLangCountry;
  secondLang: InvoiceSecondLangCode;
  bodyForPrev: AOPMaltaInvoiceDEData;
  withQR?: boolean;
}

const AOPPrev: FC<AOPPrevProps> = ({ country, secondLang, bodyForPrev, withQR = true }) => {
  const { labels } = getInvoiceDoubleLangRegistry(country, secondLang);
  const actualBg = getAdmissionOfficePreviewBackground(country, withQR);

  return (
    <div className="admission-office-prev-wrapper">
      <div className={`admission-office-prev ${country} ${secondLang} invoice`}>
        <img className="admission-office-prev-background" src={actualBg} alt="" />
        <div className="admission-office-prev-section title">{labels.invoiceTitle}</div>
        <div className="admission-office-prev-section number-and-date">
          <span>№ -</span>
          <span>{labels.datePrefix}: {bodyForPrev.currentDate ? bodyForPrev.currentDate : "-"}</span>
        </div>
        <div className="admission-office-prev-section info">
          <p>{labels.fullName}: {bodyForPrev.fullName || ""}</p>
          <p>{labels.birthDate}: {bodyForPrev.dateOfBirth || ""}</p>
          <p>{labels.nationality}: {bodyForPrev.nationalitySecondLanguage || ""}</p>
          <p>{labels.course}: {bodyForPrev.courseSecondLanguage || ""}</p>
          <p>{labels.medium}: {bodyForPrev.mediumOfInstructionSecondLanguage || ""}</p>
          <p>{labels.duration}: {bodyForPrev.durationSecondLanguage || ""}</p>
        </div>
        <div className="admission-office-prev-section signature">
          <p>{labels.signatureTop}</p>
          <p>Fedorova Anzhelika</p>
          <p>{labels.signatureBottom}</p>
        </div>
        {bodyForPrev.invoiceBodySecondLanguage?.length ? (
          <div className="admission-office-prev-section body-content">
            {bodyForPrev.invoiceBodySecondLanguage.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        ) : null}
      </div>

      <div className={`admission-office-prev ${country} invoice`}>
        <img className="admission-office-prev-background" src={actualBg} alt="" />
        <div className="admission-office-prev-section title">INVOICE</div>
        <div className="admission-office-prev-section number-and-date">
          <span>№ -</span>
          <span>Date: {bodyForPrev.currentDate ? bodyForPrev.currentDate : "-"}</span>
        </div>
        <div className="admission-office-prev-section info">
          <p>Full Name: {bodyForPrev.fullName || ""}</p>
          <p>Data of Birth: {bodyForPrev.dateOfBirth || ""}</p>
          <p>Nationality: {bodyForPrev.nationality || ""}</p>
          <p>Course: {bodyForPrev.course || ""}</p>
          <p>Medium of Instruction: {bodyForPrev.mediumOfInstruction || ""}</p>
          <p>Duration: {bodyForPrev.duration || ""}</p>
        </div>
        <div className="admission-office-prev-section signature">
          <p>Head of Foreign Students department</p>
          <p>Fedorova Anzhelika</p>
          <p>International European University</p>
        </div>
        {bodyForPrev.invoiceBody?.length ? (
          <div className="admission-office-prev-section body-content">
            {bodyForPrev.invoiceBody.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AOPPrev;
